import { render, staticRenderFns } from "./order-history.vue?vue&type=template&id=bdba1352&"
import script from "./order-history.vue?vue&type=script&lang=js&"
export * from "./order-history.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports